const data = [
  {
    "name": "Yingying Zhao",
    "en_name": "Yingying Zhao"
  },
  {
    "name": "Adil Muhammad",
    "en_name": "Adil Muhammad"
  },
  {
    "name": "Weixu Wang",
    "en_name": "Weixu Wang"
  },
  {
    "name": "Zhenrui Cao",
    "en_name": "Zhenrui Cao"
  },
  {
    "name": "Mengzhen Li",
    "en_name": "Mengzhen Li"
  },
  {
    "name": "Shuang Liu",
    "en_name": "Shuang Liu"
  },
  {
    "name": "Shuo Li",
    "en_name": "Shuo Li"
  },
  {
    "name": "Yifei Jia",
    "en_name": "Yifei Jia"
  },
  {
    "name": "Baofeng Yu",
    "en_name": "Baofeng Yu"
  },
  {
    "name": "Song Cao",
    "en_name": "Song Cao"
  },
  {
    "name": "Tingli Yuan",
    "en_name": "Tingli Yuan"
  },
  {
    "name": "Xumeng Lv",
    "en_name": "Xumeng Lv"
  },
  {
    "name": "Ziyu Niu",
    "en_name": "Ziyu Niu"
  },
  {
    "name": "Aiting Zhang",
    "en_name": "Aiting Zhang"
  },
  {
    "name": "Hao Su",
    "en_name": "Hao Su"
  },
  {
    "name": "Jiqiao Li",
    "en_name": "Jiqiao Li"
  },
  {
    "name": "Lihua Yang",
    "en_name": "Lihua Yang"
  },
  {
    "name": "Tianyu Hong",
    "en_name": "Tianyu Hong"
  },
  {
    "name": "Xiaochen Huang",
    "en_name": "Xiaochen Huang"
  },
  {
    "name": "Zhiqiang Xu",
    "en_name": "Zhiqiang Xu"
  },
  {
    "name": "Zhizhuo Pang",
    "en_name": "Zhizhuo Pang"
  },
  {
    "name": "Ziqi Gan",
    "en_name": "Ziqi Gan"
  },
  {
    "name": "Boyu Yang",
    "en_name": "Boyu Yang"
  },
  {
    "name": "Hao Ding",
    "en_name": "Hao Ding"
  },
  {
    "name": "Haonan Shen",
    "en_name": "Haonan Shen"
  },
  {
    "name": "Jianghao Bo",
    "en_name": "Jianghao Bo"
  },
  {
    "name": "Jiawei Yu",
    "en_name": "Jiawei Yu"
  },
  {
    "name": "Jinbo Huang",
    "en_name": "Jinbo Huang"
  },
  {
    "name": "Lei Shang",
    "en_name": "Lei Shang"
  },
  {
    "name": "Quanrui Wang",
    "en_name": "Quanrui Wang"
  },
  {
    "name": "Shuowen Chai",
    "en_name": "Shuowen Chai"
  },
  {
    "name": "Sicheng Ming",
    "en_name": "Sicheng Ming"
  },
  {
    "name": "Yuechong Feng",
    "en_name": "Yuechong Feng"
  },
  {
    "name": "Zhuo Xu",
    "en_name": "Zhuo Xu"
  },
  {
    "name": "Ziqi Zeng",
    "en_name": "Ziqi Zeng"
  },
  {
    "name": "Cheng Huan",
    "en_name": "Cheng Huan"
  },
  {
    "name": "Congcong Niu",
    "en_name": "Congcong Niu"
  },
  {
    "name": "Fengchao Wang",
    "en_name": "Fengchao Wang"
  },
  {
    "name": "Guangzheng Guo",
    "en_name": "Guangzheng Guo"
  },
  {
    "name": "Hao Jian",
    "en_name": "Hao Jian"
  },
  {
    "name": "Jing Zhang",
    "en_name": "Jing Zhang"
  },
  {
    "name": "Qinyang Zhang",
    "en_name": "Qinyang Zhang"
  },
  {
    "name": "Qizhou Liu",
    "en_name": "Qizhou Liu"
  },
  {
    "name": "Ruimeng Cao",
    "en_name": "Ruimeng Cao"
  },
  {
    "name": "Sichen Han",
    "en_name": "Sichen Han"
  },
  {
    "name": "Tao Yin",
    "en_name": "Tao Yin"
  },
  {
    "name": "Tianci Fu",
    "en_name": "Tianci Fu"
  },
  {
    "name": "Weijie Chen",
    "en_name": "Weijie Chen"
  },
  {
    "name": "Weijie Xu",
    "en_name": "Weijie Xu"
  },
  {
    "name": "Wenshan Jing",
    "en_name": "Wenshan Jing"
  },
  {
    "name": "Xinfu Xia",
    "en_name": "Xinfu Xia"
  },
  {
    "name": "Xiwen Luo",
    "en_name": "Xiwen Luo"
  },
  {
    "name": "Yang Liu",
    "en_name": "Yang Liu"
  },
  {
    "name": "Yawen Xue",
    "en_name": "Yawen Xue"
  },
  {
    "name": "Yike Wang",
    "en_name": "Yike Wang"
  },
  {
    "name": "Yingwenbo Wang",
    "en_name": "Yingwenbo Wang"
  },
  {
    "name": "Yuan Yuan",
    "en_name": "Yuan Yuan"
  },
  {
    "name": "Yuheng Ji",
    "en_name": "Yuheng Ji"
  },
  {
    "name": "Yulu Huang",
    "en_name": "Yulu Huang"
  },
  {
    "name": "Yunfu Han",
    "en_name": "Yunfu Han"
  },
  {
    "name": "Yuxuan Liu",
    "en_name": "Yuxuan Liu"
  },
  {
    "name": "Zeyu Ma",
    "en_name": "Zeyu Ma"
  },
  {
    "name": "Zhen Shu",
    "en_name": "Zhen Shu"
  },
  {
    "name": "Zhengyu Chen",
    "en_name": "Zhengyu Chen"
  },
  {
    "name": "Zhiwei Yang",
    "en_name": "Zhiwei Yang"
  },
  {
    "name": "Zikang Liu",
    "en_name": "Zikang Liu"
  },
  {
    "name": "Xiyu Lu",
    "en_name": "Xiyu Lu"
  },
  {
    "name": "Chaowen Xu",
    "en_name": "Chaowen Xu"
  }
];

export default data;
